import axios from "axios";

interface DownloadReportExcelParams {
  id: number;
  fileName: string;
}

export const downloadReportExcel = async ({ id, fileName }: DownloadReportExcelParams) => {
  if (!id) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";
    const response = await axios.get(
      `${baseUrl}/admin/report/${id}/excel-download`,
      {
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download quotation:", error);
    throw new Error("報告書のダウンロードに失敗しました");
  }
};


export const downloadOrderExcel = async ({ id, fileName }: DownloadReportExcelParams) => {
  if (!id) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";
    const response = await axios.get(
      `${baseUrl}/admin/order/${id}/excel-download`,
      {
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download quotation:", error);
    throw new Error("受注書のダウンロードに失敗しました");
  }
};



interface DownloadMultipleImagesZipParams {
  ids: number[];
  fileName: string;
}

/**
 * 複数報告書の画像をZIPファイルでダウンロード
 */
export const downloadMultipleReportsImagesZip = async ({ ids, fileName }: DownloadMultipleImagesZipParams) => {
  if (!ids || ids.length === 0) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";

    // IDを文字列に変換（カンマ区切り）
    const reportIds = ids.join(',');

    const response = await axios.get(
      `${baseUrl}/admin/reports/images-download`,
      {
        params: {
          report_ids: reportIds
        },
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );


    const blob = new Blob([response.data], {
      type: 'application/zip'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download multiple reports images:", error);
    throw new Error("複数報告書の画像ダウンロードに失敗しました");
  }
};

/**
 * 複数受注書の画像をZIPファイルでダウンロード
 */
export const downloadMultipleOrdersImagesZip = async ({ ids, fileName }: DownloadMultipleImagesZipParams) => {
  if (!ids || ids.length === 0) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";

    // IDを文字列に変換（カンマ区切り）
    const orderIds = ids.join(',');

    const response = await axios.get(
      `${baseUrl}/admin/orders/images-download`,
      {
        params: {
          order_ids: orderIds
        },
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/zip'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download multiple orders images:", error);
    throw new Error("複数受注書の画像ダウンロードに失敗しました");
  }
};